<div class="login-container auth-container">
  <div class="login-card auth-card card card--raised card--pad card--roomy">
    <h2>Login to Taptimize</h2>

    <form (ngSubmit)="onSubmit()" #loginForm="ngForm">
      <div class="field">
        <label class="field__label" for="email">Email</label>
        <input
          type="email"
          id="email"
          name="email"
          [(ngModel)]="loginData.email"
          required
          email
          class="input"
          placeholder="Enter your email">
      </div>

      <div class="field">
        <label class="field__label" for="password">Password</label>
        <input
          type="password"
          id="password"
          name="password"
          [(ngModel)]="loginData.password"
          required
          class="input"
          placeholder="Enter your password">
      </div>

      <div class="error-message" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>

      <button
        type="submit"
        [disabled]="!loginForm.valid || isLoading"
        class="btn btn--accent btn--block">
        <span *ngIf="isLoading">Logging in...</span>
        <span *ngIf="!isLoading">Login</span>
      </button>
    </form>

    <div class="register-link auth-link">
      <p>Don't have an account? <a href="/register" (click)="goToRegister($event)">Register here</a></p>
    </div>
  </div>
</div>
